import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  isLoading=false;
  public loadingEventEmitter: EventEmitter<boolean> = new EventEmitter();
  
  constructor() { }

  setLoading(isLoading:boolean) {
    this.isLoading = isLoading;
  } 
  public _setLoading(): void {
    if (this.isLoading) return;
    this.isLoading = true;
  }
  public _clearLoading(): void {
    if (!this.isLoading) return;
    this.isLoading = false;
  }
}
